import { usesStripePayments } from "../model/PaymentConfiguration";
import { grants } from "../backoffice.access_control";
import { useDialog } from "../hooks/useDialog";
import { ActionItem, MultipleActionsButton } from "./MultipleActionsButton";
import CreditCardIcon from "@mui/icons-material/CreditCard";
import EuroSymbolIcon from "@mui/icons-material/EuroSymbol";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { BankTransferPaymentDialogs } from "../dialogs/StudentInvoicesActionsDialog/BankTransferPaymentDialogs";
import { CashPaymentDialogs } from "../dialogs/StudentInvoicesActionsDialog/CashPaymentsDialogs";
import { CardReaderPaymentDialogs } from "../dialogs/StudentInvoicesActionsDialog/CardReaderPaymentDialogs";
import { useRecordContext } from "react-admin";
import { Student } from "../providers/studentsProvider";
import { Button } from "@mui/material";
import { drivingSchoolsProvider } from "../providers/drivingSchoolsProvider";

export function CreatePaymentButton() {
  const {
    isDialogOpen: isCardReaderPaymentDialogOpen,
    openDialog: openCardReaderPaymentDialog,
    closeDialog: closeCardReaderPaymentDialog,
  } = useDialog();
  const {
    isDialogOpen: isCashPaymentDialogOpen,
    openDialog: openCashPaymentDialog,
    closeDialog: closeCashPaymentDialog,
  } = useDialog();
  const {
    isDialogOpen: isBankTransferPaymentDialogOpen,
    openDialog: openBankTransferPaymentDialog,
    closeDialog: closeBankTransferPaymentDialog,
  } = useDialog();
  const student = useRecordContext<Student>();

  if (!student) {
    return null;
  }

  const drivingSchool = drivingSchoolsProvider.getOneFromCache(student.drivingSchoolId);

  if (!drivingSchool) {
    return null;
  }

  const branch = student.branchId ? drivingSchool.branchesById[student.branchId] : drivingSchool.defaultBranch;
  const paymentTerminalId = branch?.paymentTerminalId ?? null;

  const actionItems: ActionItem[] = [];
  if (usesStripePayments(drivingSchool) && grants.has("Invoice:createCardReaderPayment")) {
    actionItems.push({
      label: "Kartenzahlung",
      icon: <CreditCardIcon fontSize="small" />,
      onClick: openCardReaderPaymentDialog,
    });
  }
  if (grants.has("Invoice:createCashPayment")) {
    actionItems.push({
      label: "Barzahlung",
      icon: <EuroSymbolIcon fontSize="small" />,
      onClick: openCashPaymentDialog,
    });
  }
  if (grants.has("Invoice:createExternalBankTransfer")) {
    actionItems.push({
      label: "Banküberweisung",
      icon: <AccountBalanceIcon fontSize="small" />,
      onClick: openBankTransferPaymentDialog,
    });
  }
  if (actionItems.length === 0) {
    return null;
  }
  return (
    <>
      {actionItems.length > 1 ? (
        <MultipleActionsButton actionItems={actionItems} label="Einzahlung" leadingIcon={<EuroSymbolIcon />} />
      ) : (
        <Button variant="outlined" color="primary" startIcon={actionItems[0].icon} onClick={actionItems[0].onClick}>
          {actionItems[0].label}
        </Button>
      )}
      {usesStripePayments(drivingSchool) && (
        <CardReaderPaymentDialogs
          open={isCardReaderPaymentDialogOpen}
          onClose={closeCardReaderPaymentDialog}
          openDialog={openCardReaderPaymentDialog}
          paymentTerminalId={paymentTerminalId}
          drivingSchoolId={student.drivingSchoolId}
        />
      )}
      <CashPaymentDialogs
        open={isCashPaymentDialogOpen}
        onClose={closeCashPaymentDialog}
        openDialog={openCashPaymentDialog}
      />
      <BankTransferPaymentDialogs
        open={isBankTransferPaymentDialogOpen}
        onClose={closeBankTransferPaymentDialog}
        openDialog={openBankTransferPaymentDialog}
      />
    </>
  );
}
